import { ConsumerBackerActivity } from '@givebacks/api/backer';

import { IntentOption } from './types';

// Utility function to filter activity options based on user activity
export const getAvailableActivityOptions = ({
  userActivity,
  allActivityOptions,
}: {
  userActivity: ConsumerBackerActivity | undefined;
  allActivityOptions: IntentOption[];
}): IntentOption[] => {
  if (!userActivity) return [];

  const findOption = (key: string) => allActivityOptions.find((option) => option.key === key);

  const optionKeys = new Set<string>();

  // Define activity-to-options mapping
  const activityMapping = [
    {
      condition: userActivity.membership_purchase,
      options: ['view_membership_card', 'view_purchase_history'],
    },
    {
      condition: userActivity.tickets_purchased,
      options: ['view_event_tickets', 'view_purchase_history'],
    },
    {
      condition: userActivity.other_purchases,
      options: ['view_purchase_history'],
    },
    {
      condition: userActivity.earned_shop_to_give,
      options: ['view_cash_back_earned'],
    },
  ];

  // Collect all applicable option keys
  activityMapping.forEach(({ condition, options }) => {
    if (condition) {
      options.forEach((key) => optionKeys.add(key));
    }
  });

  // Convert keys to actual options
  return Array.from(optionKeys)
    .map(findOption)
    .filter((option): option is IntentOption => option !== undefined);
};
